<template>
  <v-menu min-width="330" max-width="330" allow-overflow z-index="1000" :close-on-content-click="false" top>
    <template v-slot:activator="{ on }">
      <div v-on="on">
        <mf-button v-if="localUnitTags.length === 0" text icon="add_circle" color="marca-0-l40" label="Adicionar marcador" />
        <v-row v-else-if="tagExtensiveName" no-gutters class="py-0 px-0" justify="start">
          <span v-if="localUnitTags[0]" class="tag mr-2" :style="`background-color: ${localUnitTags[0].color};`">
            {{ localUnitTags[0].name }}
          </span>
          <span v-if="localUnitTags.length > 1" class="tag mr-2" :style="`background-color: ${localUnitTags[1].color};`">
            +{{ localUnitTags.length - 1 }}
          </span>
        </v-row>
        <v-row v-else no-gutters class="py-0 px-0" justify="start">
          <span v-if="localUnitTags[0]" class="tag mr-2" :style="`background-color: ${localUnitTags[0].color};`">
            {{ localUnitTags[0].name }}
          </span>
          <span v-if="localUnitTags[1]" class="tag mr-2" :style="`background-color: ${localUnitTags[1].color};`">
            {{ localUnitTags[1].name }}
          </span>
          <span v-if="localUnitTags.length > 2" class="tag mr-2" :style="`background-color: ${localUnitTags[2].color};`">
            +{{ localUnitTags.length - 2 }}
          </span>
        </v-row>
      </div>
    </template>
    <v-card>
      <v-container class="py-0 pt-1 px-0">
        <v-row ref="selectionList" class="tags-content-selection" no-gutters>
          <v-col :class="{ 'align-content-end': filteredTagList.length === 0 && inputSearch }">
            <v-row v-for="(tag, index) of filteredTagList" :key="index" no-gutters class="py-1 px-3">
              <span class="tag" :style="`background-color: ${tag.color};`" @click="selectTag(tag)">{{ tag.name }}</span>
              <v-spacer />
              <edit-tag :tag="tag" @delete-tag="handleDeleteTag(tag)" @update-tag-name="handleUpdateTagName($event)" />
              <v-col v-if="index < filteredTagList.length - 1" cols="12">
                <v-divider class="my-1" />
              </v-col>
            </v-row>
            <div v-if="filteredTagList.length === 0 && inputSearch" class="empty-new-tag-state">
              <div class="custom-icon-container">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <mask id="mask0_2837_487" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
                    <rect width="20" height="20" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_2837_487)">
                    <path
                      d="M5.66602 10.8334L8.08268 13.2501C8.23546 13.4029 8.31185 13.5973 8.31185 13.8334C8.31185 14.0695 8.23546 14.264 8.08268 14.4167C7.9299 14.5695 7.73546 14.6459 7.49935 14.6459C7.26324 14.6459 7.06879 14.5695 6.91602 14.4167L3.08268 10.5834C2.99935 10.5001 2.94032 10.4098 2.9056 10.3126C2.87088 10.2154 2.85352 10.1112 2.85352 10.0001C2.85352 9.88897 2.87088 9.7848 2.9056 9.68758C2.94032 9.59036 2.99935 9.50008 3.08268 9.41675L6.91602 5.58341C7.06879 5.43064 7.26324 5.35425 7.49935 5.35425C7.73546 5.35425 7.9299 5.43064 8.08268 5.58341C8.23546 5.73619 8.31185 5.93064 8.31185 6.16675C8.31185 6.40286 8.23546 6.5973 8.08268 6.75008L5.66602 9.16675H15.8327V6.66675C15.8327 6.43064 15.9125 6.23272 16.0723 6.073C16.232 5.91328 16.4299 5.83341 16.666 5.83341C16.9021 5.83341 17.1 5.91328 17.2598 6.073C17.4195 6.23272 17.4993 6.43064 17.4993 6.66675V9.16675C17.4993 9.62508 17.3362 10.0174 17.0098 10.3438C16.6834 10.6702 16.291 10.8334 15.8327 10.8334H5.66602Z"
                      fill="#78838E"
                    />
                  </g>
                </svg>
              </div>
              <span class="empty-state-description">Clique enter para criar novo marcador</span>
            </div>
            <div v-else-if="availableTagList.length === 0 && !inputSearch" class="empty-state">
              <mf-icon color="cinza-l10" fill>label_off</mf-icon>
              <span>Nenhum marcador criado</span>
              <span class="empty-state-description">Digite o novo marcador abaixo e clique enter para criá-lo.</span>
            </div>
          </v-col>
        </v-row>
        <v-row class="input-selected-tags py-0 px-0 tags-selected-container" no-gutters>
          <v-col class="py-0 px-0">
            <div v-if="isMaxTagsReached" class="pl-3 my-3 d-flex align-center warning-message">
              <mf-icon small class="mb-1 ml-1 mr-1" color="vermelho-0" fill>error</mf-icon>
              Limite de {{ limitTags }} marcadores atingido
            </div>
            <v-text-field
              v-else
              v-model="inputSearch"
              autofocus
              flat
              solo
              maxlength="30"
              background-color="#ECEDF0"
              placeholder="Digite para buscar ou criar um marcador"
              single-line
              hide-details
              @keyup.enter="createTag()"
            />
            <v-row ref="selectedList" class="tags-content-selected pr-2" no-gutters>
              <v-col class="flex-wrap">
                <span v-for="(tag, index) of localUnitTags" :key="index" class="tag ml-3 mb-2" :style="`background-color: ${tag.color};`" @click="dropTag(tag)">
                  {{ tag.name }}
                  <mf-icon x-small>close</mf-icon>
                </span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-menu>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import sample from 'lodash/sample'
export default {
  name: 'UnitTags.vue',
  components: {
    EditTag: () => import('@/modules/configuracoes/lojas/views/components/EditTag.vue'),
  },
  props: {
    unitTags: {
      type: Array,
      defalt: [],
    },
    limitTags: {
      type: Number,
      default: null,
    },
    availableTags: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    inputSearch: '',
  }),
  computed: {
    localUnitTags: {
      set(value) {
        this.$emit('update:unitTags', value)
      },
      get() {
        return this.unitTags ? this.unitTags : []
      },
    },
    tagExtensiveName() {
      return this.localUnitTags[0]?.name.length > 15 || this.localUnitTags[1]?.name.length > 15
    },
    tagList() {
      return this.$store.getters.tagList
    },
    colors() {
      return [
        '#ffebee',
        '#ffcdd2',
        '#e8f5e9',
        '#c8e6c9',
        '#a5d6a7',
        '#b9f6ca',
        '#69f0ae',
        '#00e676',
        '#fce4ec',
        '#f8bbd0',
        '#f3e5f5',
        '#e1bee7',
        '#ede7f6',
        '#d1c4e9',
        '#e8eaf6',
        '#c5cae9',
        '#e3f2fd',
        '#bbdefb',
        '#e1f5fe',
        '#b3e5fc',
        '#81d4fa',
        '#4fc3f7',
        '#80d8ff',
        '#e0f7fa',
        '#b2ebf2',
        '#80deea',
        '#26c6da',
        '#84ffff',
        '#18ffff',
        '#00e5ff',
        '#e0f2f1',
        '#b2dfdb',
        '#a7ffeb',
        '#64ffda',
        '#1de9b6',
        '#f1f8e9',
        '#dcedc8',
        '#c5e1a5',
        '#aed581',
        '#9ccc65',
        '#ccff90',
        '#b2ff59',
        '#64dd17',
        '#f9fbe7',
        '#f0f4c3',
        '#e6ee9c',
        '#dce775',
        '#d4e157',
        '#cddc39',
        '#c0ca33',
        '#f4ff81',
        '#eeff41',
        '#c6ff00',
        '#aeea00',
        '#fffde7',
        '#fff9c4',
        '#fff59d',
        '#fff176',
        '#ffee58',
        '#ffeb3b',
        '#fdd835',
        '#fbc02d',
        '#ffff8d',
        '#ffff00',
        '#ffd600',
        '#fff8e1',
        '#ffecb3',
        '#ffe082',
        '#ffd54f',
        '#ffca28',
        '#ffc107',
        '#ffe57f',
        '#ffd740',
        '#ffc400',
        '#fff3e0',
        '#ffe0b2',
        '#ffcc80',
        '#ffd180',
        '#fbe9e7',
        '#ffccbc',
        '#ffab91',
        '#efebe9',
        '#d7ccc8',
      ]
    },
    isMaxTagsReached() {
      return this.limitTags !== null && this.localUnitTags.length >= this.limitTags
    },
    filteredTagList() {
      if (this.inputSearch.trim()) {
        return this.availableTags.filter((tag) => tag.name.toLowerCase().includes(this.inputSearch.toLowerCase()))
      } else {
        return this.availableTags
      }
    },
    availableTagList() {
      return this.availableTags
    },
  },
  watch: {
    inputSearch: {
      handler(value) {
        if (value.trim()) {
          this.localTagList = this.tagList.filter((tag) => tag.name.toLowerCase().includes(value.toLowerCase()))
        } else {
          this.localTagList = this.tagList
        }
      },
      immediate: true,
    },
    tagList(value) {
      this.localTagList = value
    },
    deletedTag(value) {
      this.inputSearch = ''
    },
    updatedTag(value) {
      this.inputSearch = ''
    },
  },
  methods: {
    async createTag() {
      if (!this.inputSearch.trim() || this.isMaxTagsReached) return
      const currentAdded = this.availableTags.find((item) => item.name.toLowerCase() === this.inputSearch.toLowerCase())
      if (currentAdded) {
        this.selectTag(currentAdded)
        this.inputSearch = ''
        return
      }
      const newTag = {
        name: this.inputSearch,
        color: sample(this.colors),
      }
      this.$emit('new-tag', [...this.availableTags, newTag])
      this.selectTag(newTag)
      this.inputSearch = ''
      await this.$nextTick()
      this.$refs.selectionList.scrollTop = this.$refs.selectionList.scrollHeight
    },
    async selectTag(tag) {
      if (this.isMaxTagsReached) return
      const tagList = cloneDeep(this.localUnitTags)
      const currentAdded = tagList.find((item) => item.name === tag.name)
      if (currentAdded) return
      tagList.push(tag)
      this.localUnitTags = tagList // ensures reactivity
      this.$emit('change', tagList) // ensures that parent local units list (localUnits) will be updated
      await this.$nextTick()
      this.$refs.selectedList.scrollTop = this.$refs.selectedList.scrollHeight
    },
    dropTag(tag) {
      const tagList = cloneDeep(this.localUnitTags)
      const index = tagList.findIndex((item) => item.name === tag.name)
      if (index < 0) return
      tagList.splice(index, 1)
      this.localUnitTags = tagList // ensures reactivity
      this.$emit('change', tagList) // ensures that parent local units list (localUnits) will be updated
    },
    handleDeleteTag(tagToDelete) {
      this.$emit('delete-tag', tagToDelete)
    },
    handleUpdateTagName(updateData) {
      this.$emit('update-tag-name', updateData)
    },
  },
}
</script>

<style lang="scss">
.input-selected-tags {
  background-color: $cinza-l90;
}

.flex-wrap {
  display: flex;
  flex-wrap: inherit;
}

.tags-content-selected {
  max-height: 184px;
  overflow-y: auto;
}

.tags-content-selection {
  @extend .tags-content-selected;
  height: 184px;
}

.label-tag-list {
  height: 100%;
  display: flex;
  align-items: flex-end;
}

.warning-message {
  color: $vermelho-d20;
}

.empty-state {
  border: 1px dashed $cinza-l70;
  color: $cinza-l10;
  margin: 12px;
  border-radius: 8px;
  padding: 20px 0 8px 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.empty-new-tag-state {
  color: $cinza-l10;
  margin: 12px;
  padding: 20px 0 8px 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.custom-icon-container {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
}
.empty-state-description {
  color: $cinza-l40;
}
.tags-selected-container {
  background-color: #ecedf0;
}
</style>
